export const RECEIVED_ALL_PERMISSION_TYPE = 'permission/RECEIVED_ALL_PERMISSION_TYPE';
export const RECEIVED_ALL_ROLES = 'roles/RECEIVED_ALL_ROLES';